import vue from 'vue'
import { actionDelete } from '@/components/tools'
import { sendMessage } from '@/assets/js/tools'
const that = vue.prototype
export default {
  className: 'changeAccountRecord',
  fields: [
    'name',
    'oldPhone',
    'nowPhone',
    'permissionStatus'
  ],
  search: [
    'name',
    'permissionStatus'
  ],
  action: {
    delete: false,
    create: false,
    edit: false,
    enter: {
      type: 'row',
      text: '变更',
      hidden ({ record, tags }) {
        if (record && (record.permissionStatus === 'opened' || record.permissionStatus === 'rejected')) return true
      },
      callback: async ({ record, vm }) => {
        // 获取用户信息
        let user = await vm.$modelAjax.getList('_User', {
          params: {
            limit: 1,
            where: {
              name: record.name,
              phone: record.oldPhone
            }
          }
        })
        if (!user.length) {
          throw vm.$notification['error']({
            message: '未找到该用户',
            description: '请重新尝试'
          })
        }
        let newUser = await vm.$modelAjax.getList('_User', {
          params: {
            limit: 1,
            where: {
              phone: record.nowPhone
            }
          }
        })
        if (newUser.length) {
          throw vm.$notification['error']({
            message: '已有新手机号的注册信息',
            description: '变更手机号码失败'
          })
        }
        // 修改用户信息
        await vm.$modelAjax.put('_User', user[0].objectId, { phone: record.nowPhone })
        // 修改状态
        await vm.$modelAjax.put('changeAccountRecord', record.objectId, { permissionStatus: 'opened' })
        // 如果申请表里有原手机号修改申请记录信息
        let res = await vm.$modelAjax.getList('applicationRecord', {
          params: {
            limit: 1,
            where: {
              phone: record.oldPhone
            }
          }
        })
        if (res.length) {
          await vm.$modelAjax.put('applicationRecord', res[0].objectId, {
            phone: record.nowPhone
          })
        }
        // 短信通知用户授权状态
        await sendMessage([record.nowPhone], '感谢您的耐心等待，变更手机号已成功为您办理')
        // 短信通知
        vm.$notification['success']({
          message: '您已成功办理变更手机号',
          description: '权限状态修改成功'
        })
        vm.refresh()
      }
    },
    hasEnter: {
      type: 'row',
      text: '拒绝',
      hidden ({ record, tags }) {
        if (record && (record.permissionStatus === 'opened' || record.permissionStatus === 'rejected')) return true
      },
      callback: async ({ record, vm }) => {
        // 修改数据
        await vm.$modelAjax.put('changeAccountRecord', record.objectId, { permissionStatus: 'rejected' }).catch(() => {
          throw that.$notification['error']({
            message: '该账号变更失败',
            description: '请重新尝试'
          })
        })
        // 短信通知用户授权状态
        await sendMessage([record.nowPhone], '您账号变更的内容不符合我们的要求，暂时无法为您办理希望您能谅解！')
        that.$notification['success']({
          message: '您已拒绝该账号变更请求',
          description: '权限状态修改成功'
        })
        vm.refresh()
      }
    },
    deleteRecord: {
      type: 'row',
      text: '删除',
      hidden ({ record, tags }) {
        if (record && (record.permissionStatus === 'pendingReview')) return true
      },
      callback: actionDelete
    }
  }
}
